import React, { useEffect, useState } from "react";
import { Menu, Dropdown, Timeline, Modal} from 'antd';
import styles from "./scss/landingPage.module.scss";
import { URButton } from "../../shared/widgets/button";
import { URInput } from "../../shared/widgets/input";
// import { PriorityBeam } from "../../../shared/widgets/priorityBeam";
// import { StatusTag } from "../../../shared/widgets/statusTag";
import meetnow from "./../../styles/images/landcalender.svg";
import joinnow from "./../../styles/images/landjoin.svg";
import eventsvg from "./../../styles/images/landschedule.svg";
import evengrey from "./../../styles/images/landcalendergrey.svg";
import landnodata from "./../../styles/images/nodataland.svg";
import { URCheckBox } from "../../shared/widgets/checkbox";
import CalenderTimeline from "../meeting/meetingWidgets/calenderTimeline";
import { useSelector } from "react-redux";
import { convertDuration, findHostName } from "../../base/callService/common";
import _ from "lodash";
import { LoginState } from "../../models/model";
import store from "../../context/store/store";
import CopyInvitePopUp from "../meeting/meetingWidgets/popUp/copyInvitePopUp";
import MeetingStartScreen from "../meeting/meetingWidgets/meetingStart";
import { RRuleTimeCal } from "../../base/meetingService/utils/meetingServices";
import moment from "moment";
import MainMenus from "../../common/menus";


import LeftsideBars from "./leftsidebar";
import TopHeader from "./chatsection/topheader";
import ChatTopics from "./chatsection/chattopic";
import { getMeetingLists } from "../../base/meetingService/apiService";

import { Meetingnotifications } from "../videonotifications/Meetingnotifications";
import { callMainPageInterface } from "../../models/callModel";
import { handelMeetingNotification } from "../../base/socketChatService/newChat";
import { useHistory } from "react-router-dom";
import { totalTabBatchcount,userInfo } from "../../base/socketChatService/utils";
import { SocketChatService } from "../../base/socketChatService";
import { Cookie } from "../../base/utils";
import { unregister } from "../../base/callService/callService";


type InnerEncryptionProps = {
    fromComponent: string;
    icon:any
  }
  type calendarTimeLineState = {
    isCopyModal: boolean;
    selectedMeetingDetail: any;
  }
export default function LandingPages({ fromComponent, icon }: InnerEncryptionProps) {
    let { meetingReducer }: any = useSelector((state: any) => state);
    let { meetingList } = meetingReducer;
    let { userdetails }: LoginState = store.getState().loginReducer; 
    var meetArrSplice:any = meetingList?.length >4 ?meetingList?.slice(0,4):meetingList;
    const {  toastReducer}: callMainPageInterface =  useSelector((state: callMainPageInterface) => state);
    const initalState: any = useSelector((state: any) => state.serverDisconnectReducer);
    let history = useHistory();
    useEffect(()=>{
      let chromeCount:any = totalTabBatchcount();
      document.title= chromeCount > 0 ?"Worktual Web Application ("+ chromeCount +")" : "Worktual Web Application";
      let data: any = {};
      data.offset = 0;
      data.limit = 10;
      data.filter = 'Upcoming';
      data.searchText = '';
      data.sort = '1';
      getMeetingLists(data);

    },[]);
    useEffect(()=>{
      if (toastReducer.meetingNotify.title !== undefined) {
       Meetingnotifications('topRight', toastReducer.meetingNotify, history);
       handelMeetingNotification({});
      }
    },[toastReducer.meetingNotify])
    useEffect(()=>{
      if(initalState?.serverDisconnect){
        console.log("LOgout 3")
       try{
        //Logout().then(()=>{
          const chatService = new SocketChatService(userInfo().fromID, userInfo().domainId);
          if(chatService.socketConnection){
            chatService.socketConnection.closeConnection();
            }
          chatService.destroy();
          chatService.eventEmit = null;
          chatService.socketConnection = null;
          Cookie.clear();
          localStorage.clear();
          sessionStorage.clear();
          SocketChatService._instance = null;
          unregister();
          history.push("/login");
          history.replace("/login")
       } catch(error:any){
        console.log(error,"error")
       }
  
        //});
      }
    },[initalState?.serverDisconnect]);
    const [calendarTimeLineState, setCalendarTimeLineState] = useState<calendarTimeLineState>({
        isCopyModal: false,
        selectedMeetingDetail: {}
      });
 

      const copyMeetingFun = (data: any) => {
        setCalendarTimeLineState({ ...calendarTimeLineState, isCopyModal: true, selectedMeetingDetail: data });
      };
      const copyInvitation = () => {
        setCalendarTimeLineState({ ...calendarTimeLineState, isCopyModal: false, selectedMeetingDetail: [] });
      }
    
      const redirectToMeeting = (elem: any) => {
    
        let replaced_url: any= elem.invite_url?.includes("stagemeet") ? `${elem.invite_url}${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`: `${elem.invite_url?.replace('meet.unifiedring', 'meet.worktual')}${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`;
         window.open(replaced_url, '_blank'); 
      }
   
  return (
    <>
      <div className={styles.homeEncryption}>       
           <div className={styles.landingmainconsec}>
                <div className={styles.leftsidemain}>
                <MeetingStartScreen />
                  
            </div>
            <div className={styles.rightsidemain}>
                  <div className={styles.statusContasec}>
                        <div className={styles.topheadersec}>
                                <div className={styles.leftconteside}> 
                                    <h4>Upcoming Meetings</h4>
                                    <h6>{moment(new Date()).format('dddd, DD MMMM YYYY')}</h6>
                                </div>
                                <div className={styles.righcontimg}>
                                  <img src={evengrey} alt="" />
                                </div>
                        </div>
                      
                        <div className={styles.innerbodyconsec}>
                                <div className={styles.meetingstsinnrcon}>
                                <p className={styles.meetingsCount}>5 Meetings on Today</p>
                            
                                    <div className={`scroller ${styles.timelineView}`}>
                                      {Array.isArray(meetArrSplice) && meetArrSplice?.length>0 &&  <div>
                                         <Timeline mode='left' className="custTimeline greentimeline">
                                         {meetArrSplice.map((elem: any,index:any) => {
                                            return(
                                                <Timeline.Item label={(moment(elem.start_timestamp).format('hh:mm')) + ' - ' +
                                                (moment(elem.rrule !== "" ? RRuleTimeCal(elem.start_timestamp, elem.duration_minutes) : elem.end_timestamp).format('hh:mm A'))} key={index}>
                                                <div className={styles.timelineMeet}>
                                                <div className={styles.timelineDetail}>
                                                    <p className={styles.meetTitle}>
                                                    {elem.title}
                                                    </p>
                                                   
                                                </div>
                                                <div className={styles.userbtntxtstatus}>
                                                <div className={styles.meetingsBtm}>
                                                    <div className={styles.userName}><span className="icon_timer"></span>{convertDuration(elem.duration_minutes)}</div>
                                                    <div className={styles.recType}>
                                                        <span className="icon_Profile-outline"></span>
                                                        {/* {!_.isUndefined(findHostName(elem)) ? (findHostName(elem)) : ""} */}
                                                        {elem.sip_id === userdetails.sip_login_id ? `${elem.hostName}(You)` : elem.hostName}
                                                        </div>
                                                    </div>
                                                <div className={styles.timelineBtns}>
                                                    <URButton className='urButton buttonWhite buttonSm right8' name='Copy Invitation' onClick={() => copyMeetingFun(elem)}/>
                                                    {(elem.status === "Join" || elem.status==="Start") ? <URButton className='urButton buttonBlue buttonSm' name={elem.sip_id === userdetails.sip_login_id ? "Start" : "Join"} onClick={() => redirectToMeeting(elem)}></URButton> :
                   ((elem.status === "Cancelled" || elem.status === "Missed") && elem.sip_id === userdetails.sip_login_id) ? <URButton className='urButton buttonBlue buttonSm' name="Reschedule" onClick={()=>RescheduleMeeting(elem)}></URButton> : elem.status === "Ongoing Meeting" ? <URButton className='urButton buttonBlue buttonSm' name={"Join"} onClick={() => redirectToMeeting(elem)}></URButton> :
                    elem.status ==="Rejoin" ? <URButton className='urButton buttonBlue buttonSm' name={"Re-join"} onClick={() => redirectToMeeting(elem)}></URButton> : null }
                                                </div>
                                                </div>
                                              
                                                </div>
                                            </Timeline.Item>
                                            )
                                         })
                                        }
                                        
                            
                                        </Timeline>
                                        </div> }
                                        {Array.isArray(meetingList) && meetingList?.length === 0 &&   <div className={styles.nodafouncenter}>
                                            <img src={landnodata} alt=""/>
                                            <p>No Upcoming Meetings</p>
                                        </div>}
                                    </div>
                                    
                                    {calendarTimeLineState.isCopyModal && <CopyInvitePopUp detailPage={calendarTimeLineState.selectedMeetingDetail} invitePropsCalling={copyInvitation}
        isCopyModal={calendarTimeLineState.isCopyModal} />}
                                </div>
                                
                        </div>
                        
                  </div>
                  
            </div>
     </div> 
     
      </div>
      <div className={styles.mainframe}>
        <div className={styles.framemenu}>
          <MainMenus></MainMenus>
        </div>
        <div className={"isActiveone" ? `${styles.frameleftsidebar}`
          : `${styles.frameleftsidebar} ${styles.hideframeleftsidebar}`}>
          <div className={styles.mobilemenu} ><span className="icon_close"></span></div>
          <div className={styles.landheadermainleft}>
            <LeftsideBars ></LeftsideBars>
          </div>
          
        </div>
        <div className={styles.framemain}>
          <div className={styles.frameheader}>
            <div className={styles.mobilemenu} >Menus</div>
            <TopHeader></TopHeader>
          </div>
          </div></div>
      {/* <Modal visible={true} title="Copy Meeting Invitation"
        className="customPopup meetinvite modaloverwrite"
        centered
      >
        <span className={`icon_close cutomtopclose ${styles.cursorTop}`}  />
        <div className="meetingInviteconsec" id='copyMeeting'>
        
          <div className="meetinginnerconsec">
            <p className={styles.inviteTitle}>{`${"etailPage.hostName"} is inviting
                    you to a scheduled Worktual meeting.`} </p>
            <p className="marbtmmin"><span className={styles.titleTxt}>Topic: </span></p>
            <p className="marbtmmin"><span className={styles.titleTxt}>Time:</span>
              <span className={styles.DescTxt}>
              </span>
            </p>
              
              </div>
        </div>
        <div className={styles.footersection}>
         
        </div>
      </Modal> */}

 
    </>
    
  );
};

